<template>
    <div class="main-content bg-default" style="background-image: url('assets/img/pexels-daniel-frank-1068596.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;">

            <!-- Mask & flexbox options-->
        <!-- Header -->
        <div class="header bg-transparent py-7 py-lg-8">
            <!-- <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-6 ">
                            <h1 class="">Welcome to DoItCare!</h1>
                            <h3 class="">We love trees and bicycles :)</h3>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div> -->
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-3 mb-1">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">

        </footer>
    </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false
      }
    }
  }
</script>
<style>
</style>
